import { Injectable } from '@angular/core';
import { PayerStatusFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/payer-status/payer-status-find-many-query.dto';
import { PayerStatusPageInterface } from '@zaoblako/shared/modules/catalog/dtos/payer-status/payer-status-page.dto';
import { PayerStatusFindInterface } from '@zaoblako/shared/modules/catalog/dtos/payer-status/payer-status-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisPayerStatusService extends BaseService {
  protected baseUrl = '/basis/catalog/payer-status';

  public findWithPagination(queryParams: PayerStatusFindManyQueryInterface): Observable<PayerStatusPageInterface> {
    return this.http.get<PayerStatusPageInterface>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restore(id: number): Observable<PayerStatusFindInterface> {
    return this.http.post<PayerStatusFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }
}
